var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobTracerShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #879fa0;\n      }\n\n      .cls-2 {\n        fill: #00bcb7;\n      }\n\n      .cls-3 {\n        fill: #fff145;\n      }\n\n      .cls-4 {\n        fill: #9fbec1;\n      }\n\n      .cls-5 {\n        fill: #b4d1d6;\n      }\n\n      .cls-6 {\n        fill: aqua;\n      }\n\n      .cls-7 {\n        fill: #738d8e;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "571.24 384.77 536.22 390.03 463.35 390.03 463.35 328.01 571.24 344.21 571.24 384.77"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "317.32 288.35 163.32 305.35 8.8 378.05 514.65 379.63 636.32 271.35 317.32 288.35"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "509.47 405.47 65.9 398.15 8.8 378.05 512.39 379.98 509.47 405.47"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "589.46 481.3 378.11 455.75 359.03 441.07 583.91 464.76 589.46 481.3"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "400.86 428.54 143.29 418.25 143.29 413.61 400.86 403.32 400.86 428.54"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "584.42 464.76 359.5 441.55 329.03 379.69 514.28 379.98 584.42 464.76"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "8.32 378.35 317.32 288.35 420.32 305.35 8.32 378.35"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "8.32 378.35 408.32 305.35 636.32 271.35 560.32 339.35 8.32 378.35"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "317.32 288.35 474.32 246.35 698.32 225.35 636.46 271.3 317.32 288.35"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "636.46 271.3 317.32 288.35 560.32 339.35 636.46 271.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobTracerShip);
export default __webpack_public_path__ + "static/media/mob-tracer-ship.cfd7dcc174a369e5773d41ea404110e3.svg";
export { ForwardRef as ReactComponent };